import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getSubscriptionsList,
    subscriptionsSuccess,
    subscriptionsFailed,
    getSubscription,
    subscriptionSuccess,
    subscriptionFailed,
    activeSubscription,
    subscriptionActiveSuccessfully,
    subscriptionActiveFailed,
    renewSubscription,
    subscriptionRenewSuccessfully,
    subscriptionRenewFailed,
    deleteSubscription,
    subscriptionDeletedSuccessfully,
    subscriptionDeletionFailed,
} from "../slices/subscriptionsSlice";
import {notification} from "antd";

const endpoint = '/admin/subscriptions';

function* fetchSubs(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {subscriptions} = response.data;
        if (subscriptions) {
            yield put(subscriptionsSuccess(subscriptions));
        }
    } catch (error) {
        yield put(subscriptionsFailed());
    }
}

function* fetchSub(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {subscription} = response.data;
        if (subscription) {
            yield put(subscriptionSuccess(subscription));
        }
    } catch (error) {
        yield put(subscriptionFailed());
    }
}

function* activateSubscription(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/mark_as_active/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription activated successfully'});
            yield put(subscriptionActiveSuccessfully({id}));
        }
    } catch (error) {
        yield put(subscriptionActiveFailed());
    }
}

function* reActivateSubscription(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.put, `${endpoint}/renew/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription re-activated successfully'});
            yield put(subscriptionRenewSuccessfully({id}));
        }
    } catch (error) {
        yield put(subscriptionRenewFailed());
    }
}

function* delSubscription(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/${id}`);
        if (response) {
            notification.success({message: 'Success', description: 'Subscription deleted successfully'});
            yield put(subscriptionDeletedSuccessfully({id}));
        }
    } catch (error) {
        yield put(subscriptionDeletionFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getSubscriptionsList.type, fetchSubs);
    yield takeLatest(getSubscription.type, fetchSub);
    yield takeLatest(activeSubscription.type, activateSubscription);
    yield takeLatest(renewSubscription.type, reActivateSubscription);
    yield takeLatest(deleteSubscription.type, delSubscription);
}
